export default __webpack_public_path__ + "static/1.2_EN-f4c3734bbdfa1cde7deeca657d040d89.webp";